import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceUtil } from '../utilities/service.util';
import { SgPortalDataApiServiceUtil } from '../utilities/sgportal-data-api.service.util';
import { Application } from '../models/application.model';
import { ClientApplication } from '../models/client-application.model';
import { IdentityServerClient } from '../models/identity-server-client';
import { ApplicationLinkModel } from '../models/sgportal-data-api-models/application-link.model';

@Injectable()
export class ApplicationsService {
  public confirmSaving = false;
  selectedIdentityServerClient: IdentityServerClient;
  private _controllerName: string = 'applications';
	public isSubmitted: boolean = false;

  constructor(private _serviceUtil: ServiceUtil,
    private _sgPortalApiService: SgPortalDataApiServiceUtil) { }

  async getApplications(): Promise<Application[]> {
    return this._serviceUtil.doGetRequestAsync<Application[]>(this._controllerName, 'Get');
  }

  async getApplicationsByUserId(userId: number): Promise<any> {
    const params = new HttpParams();
    params.append('userId', userId.toString());
    return await this._serviceUtil.doApiGetRequestWithParamsAsync(this._controllerName, 'User', params);
  }

  async getClientApplications(clientId: number): Promise<ClientApplication[]> {
    return await this._serviceUtil.doGetRequestAsync<ClientApplication[]>('Applications', `Client/${clientId}`);
  }
    
  async getApplicationLinksForOrganization(organizationId: number): Promise<ApplicationLinkModel[]> {
    return await this._sgPortalApiService.doGetRequestAsync<ApplicationLinkModel[]>('Application', `GetApplicationLinksForOrganization/${organizationId}`);
  }

  async upsertApplication(application: Application): Promise<any> {
    return await this._serviceUtil.doPostRequestAsync<Application, Application>(this._controllerName, 'UpsertApplication', application);
  }

  async upsertIdentityServerClient(identityServerClient: IdentityServerClient): Promise<any> {
    return await this._serviceUtil.doPostRequestAsync<IdentityServerClient, IdentityServerClient>(this._controllerName, 'UpsertIdentityServerClient', identityServerClient);
  }

  async getIdentityServerClients(): Promise<IdentityServerClient[]> {
    return await this._serviceUtil.doGetRequestAsync<IdentityServerClient[]>(this._controllerName, `GetAllIdentityServerClients`);
  }

  async getIdentityServerClientById(Id : any): Promise<IdentityServerClient>{
    const params = new HttpParams().set('Id' , Id.toString());
      return await this._serviceUtil.doGetRequestWithParamsAsync(this._controllerName,'GetIdentityServerClientById',params);
 }

 async getApplicationById(Id: string): Promise<Application> {
    const params = new HttpParams().set('Id', Id.toString());
    return await this._serviceUtil.doGetRequestWithParamsAsync(this._controllerName, 'GetApplicationById', params);
  }
}
